export const incomeSourceOptions = [
	"Self Employed",
	"Salaried",
	"Pensioner / Retired",
	"OFW",
	"Local Remittance",
	"OFW Beneficiary",
];
